var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXamarin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.164,
    height: 69.292,
    viewBox: "0 0 56.164 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xamarin-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#3498db",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "xamarian",
    transform: "translate(269.074 -334.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    d: "M-238.415,357.6h8.593a.637.637,0,0,1,.563.363l4.394,8.5a.854.854,0,0,1,0,.727l-4.351,8.454a.637.637,0,0,1-.563.363h-8.7a.637.637,0,0,1-.563-.363l-4.351-8.454a.854.854,0,0,1,0-.727l4.394-8.5a.726.726,0,0,1,.584-.363Z",
    transform: "translate(-4.764 -4.957)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(-252.694 351.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M-234.973,374.448H-246.31a.723.723,0,0,1-.63-.363l-5.644-9.835a.772.772,0,0,1,0-.727l5.741-9.859a.723.723,0,0,1,.63-.363h11.192a.723.723,0,0,1,.63.363l5.717,9.859a.772.772,0,0,1,0,.727l-5.644,9.835a.8.8,0,0,1-.655.363Zm-10.635-1.211h9.932a.723.723,0,0,0,.63-.363l4.942-8.624a.772.772,0,0,0,0-.727l-5.039-8.672a.723.723,0,0,0-.63-.363h-9.787a.723.723,0,0,0-.63.363l-5.039,8.672a.772.772,0,0,0,0,.727l4.966,8.624a.8.8,0,0,0,.655.363Z",
    transform: "translate(252.675 -353.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624",
    transform: "translate(-244.735 356.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M-219.5,384.659h0a.6.6,0,0,1-.281-.367.6.6,0,0,1,.063-.457l2.64-4.506-2.665-4.748a.606.606,0,0,1-.05-.462.606.606,0,0,1,.292-.362h0a.606.606,0,0,1,.462-.05.606.606,0,0,1,.362.292l3,5.354-2.98,5.111a.648.648,0,0,1-.843.2Z",
    transform: "translate(219.82 -373.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(-240.709 356.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M-200.2,384.822l-3-5.208,3-5.257a.6.6,0,0,1,.367-.281.6.6,0,0,1,.457.063h0a.6.6,0,0,1,.281.367.6.6,0,0,1-.063.457l-2.665,4.651,2.641,4.6a.6.6,0,0,1,.063.457.6.6,0,0,1-.281.367h0a.58.58,0,0,1-.445.06.58.58,0,0,1-.355-.276Z",
    transform: "translate(203.2 -374.056)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXamarin);
export default __webpack_public_path__ + "static/media/xamarin.7a5ca50610bb4d1b43792e327f542d4f.svg";
export { ForwardRef as ReactComponent };